import axios from "axios";
import endpoints from "hooks/api/endpoints";
import useApiGet, { UseApiGetOptions } from "hooks/api/useApiGet";
import useProjectId from "hooks/ProjectScope";
import IndividualItemResponse from "types/IndividualItemResponse";
import VideoDto, { VideoClass } from "types/VideoDto";

/** Imperative getVideo when projectId is known outside session context. */
export async function getVideoById(
  projectId: string,
  videoId: string,
): Promise<VideoDto | undefined> {
  const { data } = await axios.get<IndividualItemResponse<VideoDto>>(
    endpoints.getVideo(projectId, videoId),
  );
  return data.data;
}

export default function useGetVideoById(
  videoId: string | undefined,
  options?: {
    suspendRequest?: boolean;
  } & UseApiGetOptions,
) {
  const projectId = useProjectId();
  const { result, ...rest } = useApiGet<IndividualItemResponse<VideoDto>>(
    options?.suspendRequest ? "" : endpoints.getVideo(projectId, videoId),
    {
      axiosOptions: options?.axiosOptions,
      swrOptions: {
        dedupingInterval: 10 * 1000, // 10 seconds,
        focusThrottleInterval: 60 * 1000, // 60 seconds,
        revalidateOnFocus: false,
        ...options?.swrOptions,
      },
    },
  );

  return {
    video: result?.data ? new VideoClass(result?.data) : undefined,
    ...rest,
  };
}
